import Component from "@base/js/component";

export default class SearchResultsHero extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".search-results-hero";

  // Defines children that needs to be queried as part of this component
  static children = {
    textfield: ".search-results-hero__textfield",
    clear: ".search-results-hero__clear-button",
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    clear: {
      click: this.onClearClick,
    },
  };

  onClearClick() {
    this.children.textfield.value = "";
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
SearchResultsHero.init();
